import { useSrpContext } from '@/src/contexts'
import { useTranslations } from 'next-intl'

import DestinationInfo from './destinationInfo'

const DestinationInfoWrapper = () => {
    const {
        SEOSrpData: { sections }
    } = useSrpContext()
    const t = useTranslations('common.routeSeoContent')

    const teaser = sections?.destinationTeaser ?? null
    const legacyInfo = sections?.destination?.info ?? null
    const legacyQuickFacts = sections?.destination?.quickFacts ?? null

    const summary = teaser?.summary ?? legacyInfo?.summary ?? ''
    const title = teaser?.destinationName ?? legacyInfo?.title ?? ''
    const quickFacts = teaser?.quickFacts ?? legacyQuickFacts
    const destinationUrl = teaser?.destinationUrl ?? null
    const rawCta = teaser?.callToAction ?? (title ? t('seeMoreAbout', { city: title }) : '')
    const seeMoreLabel = rawCta ? `${rawCta.replace(/\s*→+$/, '')} →` : ''

    if (!summary) return null

    const heading = quickFacts?.country
        ? t('aboutCityCountry', { city: title, country: quickFacts.country })
        : title

    const facts: { label: string; value: string }[] = []
    if (quickFacts) {
        if (quickFacts.language) facts.push({ label: t('language'), value: quickFacts.language })
        if (quickFacts.currency) facts.push({ label: t('currency'), value: quickFacts.currency })
        if (quickFacts.bestTimeToVisit) facts.push({ label: t('bestTimeToVisitLabel'), value: quickFacts.bestTimeToVisit })
        if (quickFacts.airportName) facts.push({ label: t('airport'), value: `${quickFacts.airportName} (${quickFacts.airportCode})` })
    }

    return (
        <DestinationInfo
            heading={heading}
            overview={summary}
            quickFacts={facts}
            destinationUrl={destinationUrl}
            seeMoreLabel={seeMoreLabel}
        />
    )
}

export default DestinationInfoWrapper
